import { render, staticRenderFns } from "./ChartBox.vue?vue&type=template&id=5d40e359&scoped=true&"
import script from "./ChartBox.vue?vue&type=script&lang=js&"
export * from "./ChartBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40e359",
  null
  
)

export default component.exports